export default "__VITE_ASSET__Bi0v2yW___"